import { inject, Injectable, signal } from '@angular/core';
import { TranslationService } from './translation.service';

export type ToastType = 'success' | 'info' | 'error';

export interface ToastItem {
  id: number;
  message: string;
  type: ToastType;
}

const DURATION: Record<ToastType, number> = {
  success: 10_000,
  info: 20_000,
  error: 30_000,
};

@Injectable({
  providedIn: 'root',
})
export class PureToastService {
  readonly #translationService = inject(TranslationService);
  readonly #counter = { value: 0 };

  readonly toasts = signal<ToastItem[]>([]);

  public showSuccess(i18nMessage: string, content?: string): void {
    this.#add('success', i18nMessage, content);
  }

  public showInfo(i18nMessage: string): void {
    this.#add('info', i18nMessage);
  }

  public showError(i18nTitle: string, content?: string): void {
    this.#add('error', i18nTitle, content);
  }

  public dismiss(id: number): void {
    this.toasts.update((list) => list.filter((t) => t.id !== id));
  }

  public dismissAll(): void {
    this.toasts.set([]);
  }

  #add(type: ToastType, i18nKey: string, content?: string): void {
    const id = ++this.#counter.value;
    const base = this.#translationService.get(i18nKey);
    const message = content ? `${base}: ${content}` : base;
    this.toasts.update((list) => [...list, { id, message, type }]);
    setTimeout(() => this.dismiss(id), DURATION[type]);
  }
}
